// Fields, defaults, and library info for this section. The editor builds its form from `fields`.
const definition = {
  order: 90,
  type: "newsletter",
  name: "Newsletter Subscription",
  category: "Engagement",
  description: "Email capture box with incentive copy for discounts or alerts",
  defaultSettings: {
    title: "Subscribe to Exclusive Privileges",
    subtitle: "Be the first to hear about new arrivals, private warehouse sales, and coupon codes.",
    buttonText: "Subscribe",
    placeholder: "Enter your email address",
    backgroundColor: "#111827",
    textColor: "#ffffff",
  },
  fields: [
    { key: "title", label: "Heading", type: "text" },
    { key: "subtitle", label: "Description", type: "text" },
    { key: "buttonText", label: "Submit Button Text", type: "text" },
    { key: "placeholder", label: "Input Placeholder", type: "text" },
    { key: "backgroundColor", label: "Background Color", type: "color" },
    { key: "textColor", label: "Text Color", type: "color" },
  ],
};

export default definition;
